import React__default from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';

var Square = function Square(props) {
  return /*#__PURE__*/React__default.createElement("div", _extends({
    style: {
      width: "100%",
      paddingTop: "100%"
    }
  }, props));
};

export { Square };
//# sourceMappingURL=index.js.map
